import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      
      <main className="flex-1">
        {/* Page Header */}
        <div className="bg-white border-b mb-6">
          <div className="max-w-7xl mx-auto px-4 py-8">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Privacy Policy</h1>
            <p className="text-gray-600 mt-2">Last updated: January 2025</p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 pb-12">
          <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8">
            <div className="prose prose-gray max-w-none">
              
              {/* Developer Information */}
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-8">
                <h2 className="text-lg font-bold text-gray-800 mb-3">Developer Information</h2>
                <div className="text-gray-600 text-sm space-y-1">
                  <p><strong>Developer Name:</strong> haray</p>
                  <p><strong>Legal Name:</strong> Michelle Rachel Blumenkranz</p>
                  <p><strong>Address:</strong> 1797 NW 110th Terrace, Coral Springs - 33071-5153, United States (US)</p>
                  <p><strong>Contact Name:</strong> PRASHANT SARASWAT</p>
                  <p><strong>Contact Email:</strong> <a href="mailto:julekharay89@gmail.com" className="text-[#E53A7F] hover:underline">julekharay89@gmail.com</a></p>
                  <p><strong>Contact Phone:</strong> +1 (626) 515-7813</p>
                </div>
              </div>

              <h2 className="text-xl font-bold text-gray-800 mb-4">1. Introduction</h2>
              <p className="text-gray-600 mb-6">
                Welcome to Kiko Coupons Club ("we," "our," or "us"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and website (collectively, the "Service"). Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the Service.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">2. Information We Collect</h2>
              <p className="text-gray-600 mb-4">We may collect information about you in a variety of ways:</p>
              
              <h3 className="text-lg font-semibold text-gray-800 mb-2">2.1 Personal Data</h3>
              <p className="text-gray-600 mb-4">
                When you register for an account, we may collect personally identifiable information, such as:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-1">
                <li>Name</li>
                <li>Email address</li>
                <li>Account preferences</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-800 mb-2">2.2 Usage Data</h3>
              <p className="text-gray-600 mb-6">
                We may automatically collect certain information when you access the Service, including your device type, operating system, access times, and the pages you have viewed. This information is used to improve the Service and user experience.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">3. How We Use Your Information</h2>
              <p className="text-gray-600 mb-4">We use the information we collect to:</p>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-1">
                <li>Create and manage your account</li>
                <li>Provide and maintain our Service</li>
                <li>Save your favorite deals and preferences</li>
                <li>Send you updates about deals and promotions (if opted in)</li>
                <li>Respond to your inquiries and support requests</li>
                <li>Improve and optimize our Service</li>
                <li>Detect and prevent fraud or abuse</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-800 mb-4">4. Data Storage and Security</h2>
              <p className="text-gray-600 mb-6">
                We implement appropriate technical and organizational security measures to protect your personal information. Your data is stored securely on our servers. However, please be aware that no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">5. Data Retention</h2>
              <p className="text-gray-600 mb-6">
                We will retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. You may request deletion of your account and associated data at any time.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">6. Disclosure of Your Information</h2>
              <p className="text-gray-600 mb-4">We may share information we have collected about you in certain situations:</p>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-1">
                <li><strong>By Law or to Protect Rights:</strong> If we believe disclosure is necessary to comply with applicable law, regulation, or legal process</li>
                <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, or acquisition</li>
                <li><strong>With Your Consent:</strong> We may disclose your personal information for any other purpose with your consent</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-800 mb-4">7. Third-Party Services</h2>
              <p className="text-gray-600 mb-6">
                Our Service may contain links to third-party websites and services (merchant websites). We are not responsible for the privacy practices of these third parties. When you click on external links to merchant websites, you will be subject to their respective privacy policies. We encourage you to review the privacy policies of any third-party sites you visit.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">8. Children's Privacy</h2>
              <p className="text-gray-600 mb-6">
                Our Service is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately at <a href="mailto:julekharay89@gmail.com" className="text-[#E53A7F] hover:underline">julekharay89@gmail.com</a>, and we will take steps to delete such information.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">9. Your Rights</h2>
              <p className="text-gray-600 mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-1">
                <li>Access and receive a copy of your personal data</li>
                <li>Rectify or update your personal information</li>
                <li>Request deletion of your personal data</li>
                <li>Object to processing of your personal data</li>
                <li>Withdraw consent at any time</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-800 mb-4">10. California Privacy Rights</h2>
              <p className="text-gray-600 mb-6">
                California residents may have additional rights under the California Consumer Privacy Act (CCPA). If you are a California resident, you may request information about our collection, use, and disclosure of your personal information. To exercise your rights, please contact us at the email address below.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">11. International Users</h2>
              <p className="text-gray-600 mb-6">
                If you are accessing our Service from outside the United States, please be aware that your information may be transferred to, stored, and processed in the United States where our servers are located. By using our Service, you consent to the transfer of your information to the United States.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">12. Changes to This Privacy Policy</h2>
              <p className="text-gray-600 mb-6">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
              </p>

              <h2 className="text-xl font-bold text-gray-800 mb-4">13. Contact Us</h2>
              <p className="text-gray-600 mb-4">
                If you have any questions or concerns about this Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
                <p className="text-gray-600 text-sm"><strong>Developer:</strong> haray</p>
                <p className="text-gray-600 text-sm"><strong>Legal Name:</strong> Michelle Rachel Blumenkranz</p>
                <p className="text-gray-600 text-sm"><strong>Address:</strong> 1797 NW 110th Terrace, Coral Springs - 33071-5153, United States (US)</p>
                <p className="text-gray-600 text-sm"><strong>Contact Name:</strong> PRASHANT SARASWAT</p>
                <p className="text-gray-600 text-sm">
                  <strong>Email:</strong>{' '}
                  <a href="mailto:julekharay89@gmail.com" className="text-[#E53A7F] hover:underline">
                    julekharay89@gmail.com
                  </a>
                </p>
                <p className="text-gray-600 text-sm"><strong>Phone:</strong> +1 (626) 515-7813</p>
              </div>

              <h2 className="text-xl font-bold text-gray-800 mb-4">14. Consent</h2>
              <p className="text-gray-600 mb-6">
                By using our Service, you hereby consent to our Privacy Policy and agree to its terms.
              </p>
            </div>

            <div className="mt-8 pt-6 border-t">
              <Link to="/" className="text-[#E53A7F] hover:underline text-sm">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
